import { AxiosError } from 'axios';

export const isBackupInProgress = ({ response }: AxiosError) => {
  if (!response) {
    return false;
  }

  return response.data.code === 'website_backup_restore_in_progress';
};
